/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_True_Lion_BoltInputs */

const en_pale_true_lion_bolt = /** @type {(inputs: Pale_True_Lion_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const de_pale_true_lion_bolt = /** @type {(inputs: Pale_True_Lion_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Pale_True_Lion_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_true_lion_bolt = /** @type {((inputs?: Pale_True_Lion_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_True_Lion_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_true_lion_bolt(inputs)
	return de_pale_true_lion_bolt(inputs)
});